import React from "react";
import { useDebounce } from "./useDebounce";
export const useDebouncedState = (initialState, delay = 150, updateAction) => {
    const [getValue, setValue] = React.useState(initialState);
    const getDebouncedValue = useDebounce(getValue, delay, updateAction);
    return [getDebouncedValue, setValue];
};
//# sourceMappingURL=useDebouncedState.js.map